import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-continuancehome',
  templateUrl: './continuancehome.component.html',
  styleUrls: ['./continuancehome.component.css']
})
export class ContinuancehomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
